import { render } from "./studioLog.vue?vue&type=template&id=6148f31a&scoped=true"
import script from "./studioLog.vue?vue&type=script&lang=js"
export * from "./studioLog.vue?vue&type=script&lang=js"

import "./studioLog.vue?vue&type=style&index=0&id=6148f31a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6148f31a"]])

export default __exports__